import React from 'react'
import healthcare1 from '../images/gamergrid1.png';
import healthcare2 from '../images/gamergrid2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function GamerGrid() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">GamerGrid AI</span> – Smart Gaming Ecosystem App
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="GamerGrid AI Platform Overview"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">GamerGrid AI</span> – Smart Gaming Ecosystem App
                        </h1>

                        <p className="mb-3 ps-1">
                            GamerGrid AI is an intelligent gaming platform designed to enhance competitive gameplay and community engagement.
                            It offers AI-powered matchmaking on App and Web, in-game performance insights, player analytics, and real-time collaboration tools—all under one roof.
                        </p>

                        <p className="mb-3 ps-1">
                            Built for casual gamers, streamers, and eSports teams alike, GamerGrid delivers a seamless user experience with real-time data processing,
                            intuitive UI, and scalable infrastructure to support fast-paced, multiplayer environments.
                        </p>

                        <p className="mb-4 ps-1">
                            It simplifies team collaboration, task tracking, file management, and performance monitoring under a unified dashboard.
                            Our team built a scalable and intuitive platform focused on clean UI, smooth user experience, and powerful backend integration
                            to support thousands of concurrent users with ease.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> GamerGrid AI – Smart Gaming Ecosystem Initiative
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">UAE</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Technology & Purpose</h4>
                        <p className="mb-3 ps-3">
                            Game Behavior Analytics, AI Matchmaking, Real-Time Insights Engine, Unity, Python, WebSockets, GraphQL, Firebase
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Domain</h4>
                        <p className="mb-3 ps-3">Gaming / AI Infrastructure</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Involvement</h4>
                        <p className="mb-3 ps-3">
                            Gameplay UX Designer, 2 Frontend Engineers, Backend Architect, Multiplayer Systems Developer, AI Model Trainer, QA Lead
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Duration</h4>
                        <p className="mb-4 ps-3">6 Months</p>

                        <p className="mb-4 ps-3">
                            GamerGrid AI is a next-gen platform designed to elevate the gaming experience through smart matchmaking,
                            real-time performance analytics, and AI-assisted player development. From casual gamers to professional teams,
                            the platform analyzes gameplay data to offer personalized insights, strategic recommendations, and performance summaries—enhancing competitiveness, collaboration, and growth.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="Gaming Analytics Dashboard"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="AI Gaming Process"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            We built GamerGrid AI using scalable cloud infrastructure and advanced machine learning models trained on real-time gameplay data.
                            Our focus was on seamless cross-platform integration, low-latency communication, and intelligent matchmaking logic.
                        </p>

                        <p className="mb-3 ps-1">
                            Special attention was given to user onboarding, gamer profiles, and intuitive UI/UX to deliver an engaging, competitive-ready interface
                            for individual players and teams.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">AI-driven skill-based matchmaking</li>
                            <li className="mb-1">Real-time gameplay performance tracking</li>
                            <li className="mb-1">Personalized improvement insights and strategy suggestions</li>
                            <li className="mb-1">In-app team coordination and community tools</li>
                        </ul>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />
            </section>

        </>
    )
}

export default GamerGrid